/* global autosize */
(function ($) {
    'use strict';
    var keyCodes = {
        Backspace: 8,
        Tab: 9,
        Enter: 13,
        Esc: 27,
        Delete: 46
    };
    $.widget("fd.control_textarea", {
        options: {
            parentid: null,
            callback: function () { },
            initial: null,
            autoresize: true,
            iskeyup: false,
            iskeyupdelay: 250
        },
        initial: function (value) {
            if (value === undefined) {
                return this.options.initial;
            }

            this.options.initial = value;
            this.element.data('initial', value).attr('data-initial', value);

            return this;
        },
        resize: function () {
            autosize.update(this.element);
        },
        _create: function () {
            if (!this.options.parentid) {
                this.options.parentid = this.element.closest('[data-fd-parentid]').data('fd-parentid');
            }
            // Convert numeric options
            this.options.iskeyupdelay = Number(this.options.iskeyupdelay);

            // Prevent scrollbar from constantly showing/hiding
            this.element[0].style.overflowY = 'hidden';

            this.initial(this.element.val())._resize()._setEvents();
            if (this.options.autoresize) {
                autosize(this.element);
            }
        },
        _handleFocus: function (event) {
            var self = event.data;
            self.initial(self.element.val());
        },
        _handleBlur: function (event) {
            var self = event.data;
            self._handleSubmit(event);
        },
        _handleKeyup: function (event) {
            var self = event.data;
            if (event.which === keyCodes.Esc) {
                self.element.val(self.options.initial).focus();

                return;
            }

            if (self.options.iskeyup) {
                if (self._keyupTimer) {
                    clearTimeout(self._keyupTimer);
                }
                self._keyupTimer = setTimeout(function () {
                    self._handleSubmit(event);
                }, self.options.iskeyupdelay);
            }
        },
        _handleSubmit: function (event) {
            if (this._keyupTimer) {
                clearTimeout(this._keyupTimer);
                this._keyupTimer = null;
            }
            this.options.callback.call(this, { parentid: this.options.parentid, value: this.element.val().trim() }, event);
        },
        _keyupTimer: null,
        _resize: function () {
            if (this.element.is(':visible')) {
                this.element[0].style.height = 'inherit';

                // Get the computed styles for the element
                const computed = window.getComputedStyle(this.element[0]);

                // Calculate the height
                const height = parseInt(computed.getPropertyValue('border-top-width'), 10)
                    + parseInt(computed.getPropertyValue('padding-top'), 10)
                    + this.element[0].scrollHeight
                    + parseInt(computed.getPropertyValue('padding-bottom'), 10)
                    + parseInt(computed.getPropertyValue('border-bottom-width'), 10);

                this.element[0].style.height = height + 'px';
            }

            return this;
        },
        _setEvents: function () {
            this.element.off('focus.fdcontrol blur.fdcontrol keyup.fdcontrol')
                .on('focus.fdcontrol', null, this, this._handleFocus)
                .on('blur.fdcontrol', null, this, this._handleBlur)
                .on('keyup.fdcontrol', null, this, this._handleKeyup);

            return this;
        },
        _setOption: function (key, value) {
            this.options[key] = value;
        }
    });
}(jQuery));